import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import TrashIcon from "@mui/icons-material/DeleteRounded";
import EditIcon from "@mui/icons-material/Edit";
import { fetchOrganizations, createOrganization, deleteOrganization, SendFamilyOrgEmailInvite } from 'js/Api/index';
import { Button } from '../Component/CommonFormEle';
function OrganizationList({ onOrgClick, onAddOrganization, onDeleteOrganization, isAdmin, isSuperAdmin, }) {
    const [organizations, setOrganizations] = useState([]);
    const [deleteOrgId, setDeleteOrgId] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [showModalFamilyEmailInvite, setshowModalFamilyEmailInvite] = useState(false);
    const [newOrg, setNewOrg] = useState({
        name: "",
        contact: "",
        phoneNumber: "",
        address: "",
        code: "",
        type: "",
        email: "",
        pin: Math.floor(Math.random() * 10000)
            .toString()
            .padStart(4, "0"),
    });
    const [searchQuery, setSearchQuery] = useState("");

    const navigate = useNavigate();

    useEffect(() => {
        if (isAdmin || isSuperAdmin) {
            loadOrganizations();
        }
    }, [isAdmin, isSuperAdmin]);

    const loadOrganizations = async () => {
        const result = await fetchOrganizations();
        if (result.success) {
            setOrganizations(result.data);
        } else {
            console.error("Failed to fetch organizations:", result.error);
        }
    };

    const handleAddClick = () => {
        setNewOrg({
            name: "",
            contact: "",
            phoneNumber: "",
            address: "",
            code: "",
            type: "",
            email: "",
            pin: Math.floor(Math.random() * 10000)
                .toString()
                .padStart(4, "0"),
        });
        setShowModal(true);
    };

    const handleInputChange = (e) => {
        if (e.target.name === "name") {
            setNewOrg({ ...newOrg, "name": e.target.value, "code": e.target.value.replaceAll(" ", "").toUpperCase() });
        }
        else {
            setNewOrg({ ...newOrg, [e.target.name]: e.target.value });
        }
    };

    const handleSaveClick = async (e) => {
        e.preventDefault();
        if (!newOrg.type.trim()) {
            toast.error("Organisation Type required!");
            return;
        }
        if (!newOrg.name.trim()) {
            toast.error("Name is required!");
            return;
        }
        if (!newOrg.code.trim()) {
            toast.error(newOrg.type === "family" ? "Family Id is required!" : "Organisation Id is required!");
            return;
        }
        if (newOrg.type === "family" && !newOrg.email.trim()) {
            toast.error("Email is  required!");
            return;
        }
        if (newOrg.type === "family" && newOrg.email.trim()) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(newOrg.email)) {
                toast.error("Enter a valid email!");
                return;
            }
        }

        if (newOrg.type === "family") {
            setshowModalFamilyEmailInvite(true);
        }
        else {
            await CreateNewOrg(false);
        }

    };

    const CreateNewOrg = async (sendEmail) => {
        const result = await createOrganization(newOrg);

        if (result.success) {
            if (sendEmail) {
                await SendFamilyOrgEmailInvite(newOrg.email, newOrg.name);
            }

            setShowModal(false);
            onAddOrganization(result.data);
            onOrgClick(result.data);
            loadOrganizations();
            toast.success(result.message);
        } else {
            toast.error(result.error);
        }
    }

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    };

    const filteredOrganizations = organizations.filter((org) =>
        Object.values(org).some(
            (value) =>
                value &&
                value.toString().toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const truncateAddress = (address) => {
        const maxLength = 30;
        if (address && address.length > maxLength) {
            return address.substring(0, maxLength) + "...";
        }
        return address || "No address provided";
    };

    const handleDeleteClick = (orgId) => {
        setDeleteOrgId(orgId);
    };

    const handleDeleteConfirm = async () => {
        const result = await deleteOrganization(deleteOrgId);

        if (result.success) {
            await onDeleteOrganization(deleteOrgId);
            setDeleteOrgId(null);
            loadOrganizations();
            toast.success(result.message);
        } else {
            toast.error(result.message);
        }
    };

    const handleDeleteCancel = () => {
        setDeleteOrgId(null);
    };

    const handleEditClick = (orgGuid) => {
        navigate(`/userboard/${orgGuid}`);
    };

    return (
        <div className="midde_cont">
            <div className="container-fluid">
                <div className="row column_title">
                    <div className="col-md-12">
                        <div className="page_title">
                            <h2>Organisation</h2>
                        </div>
                    </div>
                </div>
                <div class="white_shd full margin_bottom_30">
                    <div class="full inner_elements">
                        <div class="padding_infor_info">
                            <div class="actions row" style={{ paddingTop: "0px" }} >
                                <div class="col">
                                    <Button onClick={handleAddClick} variant="action-popup">
                                        Add +
                                    </Button>
                                </div>
                                <div class="col">
                                    <div className="search-wrapper">
                                        <input type="text" placeholder="Search" className="search-input"
                                            value={searchQuery} onChange={handleSearchChange} />
                                        <i className="search-icon"></i>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="table-wrap">
                                        <table className="table table-hover">
                                            <thead>
                                                <tr>
                                                    <th width="10%">ID</th>
                                                    <th width="18%">Name</th>
                                                    <th width="10%">Type</th>
                                                    <th width="18%">Contact Person</th>
                                                    <th width="18%">Phone Number</th>
                                                    <th>Address</th>
                                                    {isAdmin || isSuperAdmin ? <th width="10%">&nbsp;</th> : null}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {filteredOrganizations.sort((a, b) => a.name.localeCompare(b.name)).map((org) => (
                                                    <tr key={org.id} onClick={() => handleEditClick(org.id)}>
                                                        <td>{org.code}</td>
                                                        <td>{org.name}</td>
                                                        <td>{org.orgType}</td>
                                                        <td>{org.contact}</td>
                                                        <td>{org.phoneNumber}</td>
                                                        <td>{truncateAddress(org.address)}</td>
                                                        {isAdmin || isSuperAdmin ? (
                                                            <td>
                                                                <TrashIcon sx={{ fontSize: "1.5rem", color: "black", marginRight: "10px", cursor: "pointer", }}
                                                                    onClick={(e) => { e.stopPropagation(); handleDeleteClick(org.id); }} />
                                                                <EditIcon onClick={(e) => { e.stopPropagation(); onOrgClick(org); }}
                                                                    sx={{ fontSize: "1.5rem", color: "black", marginRight: "10px", cursor: "pointer", }} />
                                                            </td>
                                                        ) : null}
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {showModal && (
                <div className="modal" role="dialog">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content" style={{ width: "400px" }}>
                            <div className="modal-header">
                                <h1 className="modal-title">Add Organisation</h1>
                                <Button onClick={() => setShowModal(false)} variant="modal-close">
                                    &times;
                                </Button>
                            </div>
                            <form className="contact-form">
                                <div className="form-group">
                                    <label htmlFor="name">Type</label>
                                    <select className="form-control" name="type" id="type" value={newOrg.type} onChange={handleInputChange}>
                                        <option value="">Select Type</option>
                                        <option value="organisation">Organisation</option>
                                        <option value="family">Family</option>
                                    </select>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="name">{newOrg.type === "family" ? "Purchaser's Name" : "Name"}</label>
                                    <input type="text" className="form-control" name="name" id="name" value={newOrg.name} onChange={handleInputChange} />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="organizationId">{newOrg.type === "family" ? "Family Id" : "Organisation Id"}</label>
                                    <input type="text" className="form-control" name="code" id="organizationId" value={newOrg.code} onChange={handleInputChange} required />
                                </div>
                                {newOrg.type === "family" ?
                                    <div className="form-group">
                                        <label htmlFor="contact">Purchaser’s Email Address</label>
                                        <input type="email" className="form-control" name="email" id="email" value={newOrg.email} onChange={handleInputChange} />
                                    </div>
                                    :
                                    <div className="form-group">
                                        <label htmlFor="contact">Contact Person</label>
                                        <input type="text" className="form-control" name="contact" id="contact" value={newOrg.contact} onChange={handleInputChange} />
                                    </div>
                                }
                                <div className="form-group">
                                    <label htmlFor="phoneNumber">{newOrg.type === "family" ? "Purchaser's Phone Number (optional)" : "Phone Number"}</label>
                                    <input type="text" className="form-control" name="phoneNumber" id="phoneNumber" value={newOrg.phoneNumber} onChange={handleInputChange} />
                                </div>
                                {newOrg.type === "family" ? null :
                                    <div className="form-group">
                                        <label htmlFor="address">Address</label>
                                        <input type="text" className="form-control" name="address" id="address" value={newOrg.address} onChange={handleInputChange} />
                                    </div>
                                }
                                <div className="modal-footer">
                                    <Button onClick={() => setShowModal(false)} variant="cancel">
                                        Cancel
                                    </Button>
                                    <Button onClick={handleSaveClick} variant="blue">
                                        Save
                                    </Button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}

            {showModalFamilyEmailInvite && (
                <div className="modal" role="dialog">
                    <div className="modal-dialog" role="document" style={{ width: "400px" }}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h1 className="modal-title">Invite Family Organisation</h1>
                                <Button onClick={() => setshowModalFamilyEmailInvite(false)} variant="modal-close">
                                    &times;
                                </Button>
                            </div>
                            <form className="contact-form">
                                <div className="form-group">
                                    <br />
                                    Would you like to send an invitation email to {newOrg.email}?
                                </div>
                                <div className="modal-footer">
                                    <Button onClick={() => setshowModalFamilyEmailInvite(false)} variant="cancel">
                                        Cancel
                                    </Button>
                                    <Button onClick={(e) => { e.preventDefault(); CreateNewOrg(false) }} variant="blue">
                                        Don't Send Email
                                    </Button>
                                    <Button onClick={(e) => { e.preventDefault(); CreateNewOrg(true) }} variant="blue">
                                        Send Email
                                    </Button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}

            {deleteOrgId && (
                <div className="modal fade show" style={{ display: "block" }} aria-modal="true" role="dialog" >
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h1 className="modal-title">Delete Organisation</h1>
                                <Button onClick={handleDeleteCancel} variant="modal-close">
                                    &times;
                                </Button>
                            </div>
                            <div className="modal-body">
                                <p>
                                    Are you sure to delete{" "}
                                    <strong>
                                        {organizations.find((org) => org.id === deleteOrgId)?.name}
                                    </strong>
                                    &nbsp;?
                                </p>
                            </div>
                            <div className="modal-footer">
                                <Button onClick={handleDeleteCancel} variant="cancel">
                                    Cancel
                                </Button>
                                <Button onClick={handleDeleteConfirm} variant="delete">
                                    Delete
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default OrganizationList;